import React from 'react';

interface PackagingSectionProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const PackagingSection: React.FC<PackagingSectionProps> = ({ value, onChange, disabled }) => {
  return (
    <div className="border rounded-lg p-6 bg-white">
      <h4 className="text-lg font-semibold mb-5 text-blue-700 border-b pb-2 flex items-center gap-2">
        <span>📦</span> 3.2. Empaque
      </h4>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm">
          <tbody>
            <tr>
              <td className="px-3 py-2 text-xs font-semibold text-gray-600 uppercase tracking-wide bg-gray-50 border border-gray-300 w-44">
                Instrucciones
              </td>
              <td className="px-2 py-2 border border-gray-300">
                <input
                  type="text"
                  className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:ring-1 focus:ring-blue-400 focus:border-blue-400 bg-white disabled:bg-gray-50"
                  placeholder="Capturar valor"
                  value={value}
                  onChange={(e) => onChange(e.target.value)}
                  disabled={disabled}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PackagingSection;
